import { Button, Input } from "@mui/material";
import { tss } from "tss-react";
import { VisibilityOff, Delete } from "@mui/icons-material";

const useStyles = tss.create({
    button: {
        minWidth: 20,
        padding: "5px 5px",
    },
    disabled: {
        opacity: 0.25,
    },
    rightDiv: {
        position: "absolute",
        display: "inline-flex",
        alignItems: "center",
        right: 0,
        width: 110,
        height: "100%",
        userSelect: "none",
    },
    separator: {
        height: 40,
        width: 40,
        borderLeft: "solid 1px #adbbd3",
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
    },
    toolIcon: {
        width: 20,
        height: 20,
    },
    grey: {
        minWidth: 16,
        color: "#AAAAAA",
    },
    opacityInput: {
        "& input": {
            width: 53,
            height: 15,
            outline: 0,
            border: 0,
            borderBottom: "solid 1px #adbbd3",
            textAlign: "center",
            fontSize: 14,
            letterSpacing: 0,
            lineHeight: "16px",
            backgroundColor: "transparent",
        },
    },
});

type ITooltip = {
    id: string;
    actions: any;
    values: any;
};

export default function Tooltip(props: ITooltip) {
    const { classes, cx } = useStyles();
    const { id, actions, values } = props;
    const { setTransparency, toggleVisibility, deleteImage } = actions;
    const { isVisible, opacity } = values;
    return (
        <div id={id} style={{ display: "none" }} className={classes.rightDiv} draggable={false}>
            <div className={classes.separator}>
                <Button
                    className={classes.button}
                    variant={"text"}
                    onClick={() => {
                        deleteImage();
                    }}
                >
                    <Delete titleAccess="Delete" className={classes.toolIcon} />
                </Button>
            </div>
            <div className={classes.separator}>
                <Button
                    className={isVisible ? classes.button : cx(classes.button, classes.grey)}
                    variant={"text"}
                    onClick={() => {
                        toggleVisibility();
                    }}
                >
                    <VisibilityOff titleAccess="Show/Hide" className={classes.toolIcon} />
                </Button>
            </div>
            <div className={classes.separator} style={{ width: 76 }}>
                <Input
                    type="number"
                    id={id + "-input"}
                    value={Math.round(opacity)}
                    className={classes.opacityInput}
                    inputProps={{ min: 0, max: 100, step: 1 }}
                    disableUnderline={true}
                    disabled={!isVisible}
                    onChange={(evt: any) => setTransparency(evt.target.value)}
                />
            </div>
        </div>
    );
}
